import {Controller, useFormContext} from "react-hook-form";
import {TreatmentHoldInitiatorMap} from "../../domain";
import {SimpleDropdown} from "../../../../common";
import React from "react";
import {TreatmentHoldInput} from "./TreatmentHoldFormModal";

type ServiceTypeInputProps = {
    sending: boolean;
};

export function HoldTypeInput({sending}: ServiceTypeInputProps) {
    const {
        setValue,
        clearErrors,
        control,
    } = useFormContext<TreatmentHoldInput>();

    return (
        <div className="w-full text-black-200 pb-2 text-base items-center">
            <div className="flex items-center">
                <div className="w-2/6 text-right">
                    Initiator
                </div>
                <div className="w-2/6 ml-4">
                    <Controller
                        name="holdType"
                        control={control}
                        rules={{
                            required: "Please select 'Initiator' before submitting",
                        }}
                        render={({field: {value}, fieldState: {error}}) => (
                            <>
                                <SimpleDropdown
                                    options={TreatmentHoldInitiatorMap}
                                    selected={value}
                                    disabled={sending}
                                    hasErrorBorder={error !== undefined}
                                    setSelected={(selected) => {
                                        setValue("holdType", selected);
                                        clearErrors("holdType");
                                    }}
                                    textColor={"black-200"}
                                />
                                {error && <div className="text-red-700 mt-1">{error.message}</div>}
                            </>
                        )}/>
                </div>
            </div>
        </div>
    );
}
